import { render } from "./CouponView.vue?vue&type=template&id=e92184ee"
const script = {}

import exportComponent from "/builds/psj7085139/sam/samva-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__